<template>
  <div>
    <b-modal
      ref="modal-primary "
      id="modal-primary"
      modal-class="modal-primary"
      centered
      title="Stok Ekle/Güncelle"
    >
      <div>
        <b-row>
          <b-col>
            <vs-card>
              <b-form @submit.prevent>
                <b-row style="margin-bottom: 10px">
                  <b-col cols="4" align-self="center">
                    <b-form-group
                      label="Stok No"
                      label-for="h-first-name"
                      style="font-size: 15px"
                    >
                    </b-form-group>
                  </b-col>

                  <b-col cols="8">
                    <b-form-input
                      id="h-first-name"
                      :disabled="degerKontrol == true"
                      v-model="stokNo"
                    />
                  </b-col>
                </b-row>
                <b-row style="margin-bottom: 10px">
                  <b-col cols="4" align-self="center">
                    <b-form-group
                      label="Barkod"
                      label-for="h-first-name"
                      style="font-size: 15px"
                    >
                    </b-form-group>
                  </b-col>
                  <b-col cols="8">
                    <b-form-input id="h-first-name" v-model="barkod" />
                  </b-col>
                </b-row>
                <b-row style="margin-bottom: 10px">
                  <b-col cols="4" align-self="center">
                    <b-form-group
                      label="Stok Adı"
                      label-for="h-first-name"
                      style="font-size: 15px"
                    >
                    </b-form-group>
                  </b-col>
                  <b-col cols="8">
                    <b-form-input
                      :disabled="degerKontrol == true"
                      id="h-first-name"
                      v-model="stokAdi"
                    />
                  </b-col>
                </b-row>
                <b-row style="margin-bottom: 10px">
                  <b-col cols="4" align-self="center">
                    <b-form-group
                      label="Grup Kodu"
                      label-for="h-first-name"
                      style="font-size: 15px"
                    >
                    </b-form-group>
                  </b-col>
                  <b-col cols="8">
                    <v-select
                      :color="select2"
                      v-model="grupkodSecilen"
                      :options="grupkod"
                      @input="changedLabel"
                      style="
                        border-top-right-radius: 0;
                        border-bottom-right-radius: 0;
                      "
                      autocomplete
                      ref="selectElement"
                    >
                    </v-select>
                  </b-col>
                </b-row>

                <b-row>
                  <b-col cols="4" align-self="center">
                    <b-form-group
                      label="Açıklama"
                      label-for="h-first-name"
                      style="font-size: 15px"
                    >
                    </b-form-group>
                  </b-col>
                  <b-col cols="8">
                    <vs-textarea label="Açıklama" v-model="textareaNot" />
                  </b-col>
                </b-row>
                <b-row style="margin-bottom: 10px">
                  <b-col cols="4" align-self="center">
                    <b-form-group
                      label="Birim"
                      label-for="h-first-name"
                      style="font-size: 15px"
                    >
                    </b-form-group>
                  </b-col>
                  <b-col cols="8">
                    <v-select
                      :color="select2"
                      v-model="birimSecilen"
                      :options="birim"
                      @input="changedLabel"
                      style="
                        border-top-right-radius: 0;
                        border-bottom-right-radius: 0;
                      "
                      autocomplete
                      ref="selectElement"
                    >
                    </v-select>
                  </b-col>
                </b-row>
                <b-row style="margin-bottom: 10px">
                  <b-col cols="4" align-self="center">
                    <b-form-group
                      label="Birim Ağırlık"
                      label-for="h-first-name"
                      style="font-size: 15px"
                    >
                    </b-form-group>
                  </b-col>
                  <b-col cols="8">
                    <b-form-input id="h-first-name" v-model="birimAgırlık" />
                  </b-col>
                </b-row>
              </b-form>
            </vs-card>
          </b-col>
        </b-row>
      </div>
      <template #modal-footer>
        <div class="w-100">
          <vs-button
            style="border-radius: 5px"
            type="gradient"
            color="danger"
            class="float-right"
            @click="cancel()"
            >İptal</vs-button
          >

          <vs-button
            style="border-radius: 5px"
            type="gradient"
            color="success"
            class="float-right"
            @click="stokKaydet()"
            >Kaydet</vs-button
          >
        </div>
      </template>
    </b-modal>
  </div>
</template>
<script>
import Store from "../../../../store/store";
import state from "../../../../store/state";
import vSelect from "vue-select";
import moment from "moment";
export default {
  data() {
    //vm.stokID == "" ||
    return {
      inputValFiyat: "",
      select2: "primary",
      grupkod: ["Ara Karton", "Etiket", "Ön Karton"],
      grupkodSecilen: "",
      stokNo: "",
      barkod: "",
      stokAdi: "",
      textareaNot: "",
      query: "",
      querystok: "",
      filteredOptions: [],
      filteredOptionsstok: [],
      datasuggest: [],
      datasuggeststok: [],
      birimAgırlık: "",
      ACTNAME: "",
      ACTID: "",
      gelenSTOCKNO: "",
      gelenSTOCKID: "",
      gelenSTOCKNAME: "",
      stokIdSecilen: "",
      RECEIPTID: "",
      ITEMNO: "",
      birimSecilen: "",
      birim: ["Adet", "Kg", "Metre", "Ton"],
      degerKontrol: false,
      stokID: "",
    };
  },
  components: { "v-select": vSelect },
  methods: {
    changedLabel(event) {
      this.inputValFiyat = event.ACTID;
    },

    getNow() {
      const today = new Date();
      const date =
        today.getDate() +
        "." +
        (today.getMonth() + 1) +
        "." +
        today.getFullYear();

      const dateTime = date;
      return dateTime;
    },
    cancel() {
      this.$refs["modal-primary "].hide();
      this.stokID = "";
      this.stokNo = "";
      this.barkod = "";
      this.stokAdi = "";
      this.grupkodSecilen = "";
      this.birimAgırlık = "";
      this.birimSecilen = "";
      this.textareaNot = "";
    },
    parseDate(params) {
      return moment(String(params.value)).format("DD.MM.YYYY");
    },
    stokKaydet() {
      var vm = this;
      const vs = this.$vs;

      const soap = require("soap");
      const url = state.sistemAddress;
      if (vm.stokNo == "" || vm.stokAdi == "") {
        vs.notify({
          title: "Stok",
          text: "Stok adı ve Stok no alanı boş olmamalı.",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger",
          position: "top-center",
        });
      } else {
        const args = {
          token: Store.state.tokenId,
          ISLEM: "",
          ARANAN: "",
          STATUS: "",

          STOCKID: vm.stokID,
          STOCKNO: vm.stokNo,
          BARKOD: vm.barkod,
          STOCKNAME: vm.stokAdi,
          GROUPCODE: vm.grupkodSecilen,
          BIRIMAGIRLIK: vm.birimAgırlık,
          BIRIM: vm.birimSecilen,
          DESCRIPTION: vm.textareaNot,
          INSERTUSERID: Store.state.UserId,
          EDITUSERID: Store.state.UserId,
        };
        soap.createClient(url, function (err, client) {
          client.UZM_STOCKINS(args, function (err, result) {
            if (result.UZM_STOCKINSResult == "-1") {
              Store.dispatch("logout");
            }
            console.log(result.UZM_STOCKINSResult);
            try {
              if (result.UZM_STOCKINSResult == "Yes") {
                vm.$root.$emit("stoklistele");
                vs.notify({
                  title: "Stok",
                  text: "Stok kaydı tamamlandı.",
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "success",
                  position: "top-center",
                });
                vm.$refs["modal-primary "].hide();
                vm.stokID = "";
                vm.stokNo = "";
                vm.barkod = "";
                vm.stokAdi = "";
                vm.grupkodSecilen = "";
                vm.birimAgırlık = "";
                vm.birimSecilen = "";
                vm.textareaNot = "";
              } else {
                vs.notify({
                  title: "Stok",
                  text:
                    "Stok kaydı tamamlanamadı. " + result.UZM_STOCKINSResult,
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "danger",
                  position: "top-center",
                });
              }
            } catch (error) {
              console.log(error);
            }
          });
        });
      }
    },
    stokDetayComponent(gelen) {
      this.$refs["modal-primary "].show();
      if (typeof gelen != "undefined") {
        this.degerKontrol = true;
        this.stokNo = gelen.STOCKNO;
        this.barkod = gelen.BARKOD;
        this.stokAdi = gelen.STOCKNAME;
        this.textareaNot = gelen.DESCRIPTION;
        this.grupkodSecilen = gelen.GROUPCODE;
        this.birimSecilen = gelen.BIRIM;
        this.birimAgırlık = gelen.BIRIMAGIRLIK;
        this.stokID = gelen.STOCKID;
      }
    },
  },
};
</script>
<style lang="scss">
#modal-primary___BV_modal_outer_ {
  z-index: 105000 !important;
}
[dir="ltr"] .modal .modal-header,
[dir="rtl"] .modal .modal-header {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}
[dir] .modal .modal-header {
  background-color: #f8f8f8;
  border-bottom: none;
}
[dir="ltr"] .modal-header,
[dir="rtl"] .modal-header {
  border-top-left-radius: calc(0.358rem - 1px);
  border-top-right-radius: calc(0.358rem - 1px);
}
[dir] .modal-header {
  padding: 0.8rem 1.4rem;
  border-bottom: 1px solid #ebe9f1;
}

[dir="ltr"] .modal .modal-header .close:active,
[dir="ltr"] .modal .modal-header .close:focus,
[dir="ltr"] .modal .modal-header .close:hover {
  -webkit-transform: translate(5px, 3px);
  transform: translate(5px, 3px);
}

[dir] .modal .modal-header .close:active,
[dir] .modal .modal-header .close:focus,
[dir] .modal .modal-header .close:hover {
  -webkit-box-shadow: none;
  box-shadow: none;
}
.modal.modal-primary .modal-header .close {
  color: #7367f0 !important;
}
.modal .modal-header .close:active,
.modal .modal-header .close:focus,
.modal .modal-header .close:hover {
  opacity: 1;
  outline: none;
}
[dir="ltr"] .modal-header .close {
  margin: -0.8rem -1.4rem -0.8rem auto;
}
[dir] .modal .modal-header .close {
  padding: 0.2rem 0.62rem;
  -webkit-box-shadow: 0 5px 20px 0 rgb(34 41 47 / 10%);
  box-shadow: 0 5px 20px 0 rgb(34 41 47 / 10%);
  border-radius: 0.357rem;
  background: #fff;
}
.modal-header {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: start;
  -ms-flex-align: start;
  align-items: flex-start;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
}
#autosuggest__input {
  outline: none;
  position: relative;
  display: block;
  width: 100%;
  box-sizing: border-box;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
}

#autosuggest__input.autosuggest__input-open {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.autosuggest__results-container {
  position: relative;
  width: 100%;
}
[dir] .autosuggest__results .autosuggest__results-item {
  padding: 7px !important;
}
[dir] .card-text:last-child {
  color: black;
  font-weight: 500;
}
.autosuggest__results {
  font-weight: 300;
  margin: 0;
  position: absolute;
  z-index: 10000001;
  width: 100%;
  border: 1px solid #e0e0e0;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  background: white;
  padding: 0px;
  max-height: 100px;
  overflow-y: scroll;
}

.autosuggest__results ul {
  list-style: none;
  padding-left: 0;
  margin: 0;
}

.autosuggest__results .autosuggest__results-item {
  cursor: pointer;
  padding: 15px;
}

#autosuggest ul:nth-child(1) > .autosuggest__results-before {
  border-top: none;
}

.autosuggest__results .autosuggest__results-before {
  color: gray;
  font-size: 11px;
  margin-left: 0;
  padding: 15px 13px 5px;
  border-top: 1px solid lightgray;
}

.autosuggest__results .autosuggest__results-item:active,
.autosuggest__results .autosuggest__results-item:hover,
.autosuggest__results .autosuggest__results-item:focus,
.autosuggest__results
  .autosuggest__results-item.autosuggest__results-item--highlighted {
  background-color: #f6f6f6;
}
</style>